export default __webpack_public_path__ + "static/media/model-custom.56e678d2.jpg";